export default {
    methods: {
        formatDate(date, format) {
            date = new Date(date);

            let j = Number(date.getDate());
            let d = (j < 10) ? '0' + j : j;
        
            let n = Number(date.getMonth()) + 1;
            let m = (n < 10) ? '0' + n : n;
        
            let Y = Number(date.getFullYear());
        
            let G = Number(date.getHours());
            let H = (G < 10) ? '0' + G : G;
        
            let i = (Number(date.getMinutes()) < 10) ? '0' + Number(date.getMinutes()) : Number(date.getMinutes());
            let s = (Number(date.getSeconds()) < 10) ? '0' + Number(date.getSeconds()) : Number(date.getSeconds());
        
            var mapObj = {
                j:j,
                d:d,
                n:n,
                m:m,
                Y:Y,
                G:G,
                H:H,
                i:i,
                s:s,
            };
        
            let retval = format.replace(/j|d|n|m|Y|G|H|i|s/gi, function(matched){
                return mapObj[matched];
            });
        
            return retval;
        },
    },
};